<template>
	<div>
		<el-divider>{{ documentInfo.did ? '修改' : '添加' }}内容</el-divider>
		<el-form class="text-left" ref="documentForm" :rules="rules" :model="documentInfo" style="width: 80%;margin: 0 auto;">
			<el-form-item v-if="mlabel" label="所属模型" :label-width="formLabelWidth" prop="mlabel">{{ mlabel }}</el-form-item>
			<el-form-item label="自定义标题颜色" :label-width="formLabelWidth" prop="mlabel">
				<el-color-picker v-model="documentInfo.titlecolor" @change="changeThemeColor"></el-color-picker>
			</el-form-item>
			<el-form-item v-if="documentInfo.did" label="添加时间" :label-width="formLabelWidth" prop="addtime">
				<el-date-picker v-model="documentInfo.addtime" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
			</el-form-item>
			<el-form-item v-if="documentInfo.istsn" label="内容编号" :label-width="formLabelWidth" prop="tsn">
				<el-input v-model="documentInfo.tsn" autocomplete="off"></el-input>
			</el-form-item>

			<el-form-item v-for="(attr, index) in modelAttr" :key="index" :label="attr.typename" :label-width="formLabelWidth" :prop="attr.attrname">
				<template v-if="attr.inputtype == 'img'">
					<el-button v-if="!documentInfo[attr.attrname]" size="small" type="primary" @click="addPic(attr.attrname, 'one')">上传图片</el-button>
					<div v-else class="upfile">
						<div class="delicon text-right"><i class="el-icon-delete" @click="delAdscopeImg(attr.attrname)"></i></div>
						<img v-if="documentInfo[attr.attrname]" :src="HOST + documentInfo[attr.attrname]" alt="" style="width: 150px;height: 150px;" />
					</div>
				</template>
				<template v-else-if="attr.inputtype == 'htmltext'">
					<el-input
						type="textarea"
						v-model="documentInfo[attr.attrname]"
						:rows="4"
						autocomplete="off"
						:autosize="{ minRows: 4, maxRows: 8 }"
						:placeholder="attr.typeremark"
					></el-input>
				</template>
				<template v-else-if="attr.inputtype == 'editor'">
					<div v-if="elseAttr[attr.attrname]">
						<vue-ueditor-wrap class="editor" @ready="ready" :destroy="true" v-model="documentInfo[attr.attrname]" :config="myConfig"></vue-ueditor-wrap>
					</div>
					<el-checkbox v-model="attr.is_pictonative" @change="e => changeEditorOpt(attr.attrname, 'catchRemoteImageEnable', e)">下载网络图片到本地</el-checkbox>
					<el-checkbox v-model="attr.is_addwaterpic" :true-label="1" :false-label="0" @change="e => changeEditorOpt(attr.attrname, 'iswatermarker', e)">
						图片添加水印
					</el-checkbox>
				</template>
				<template v-else-if="attr.inputtype == 'selectinput'">
					<el-input v-model="documentInfo[attr.attrname]" autocomplete="off" :placeholder="attr.typeremark"></el-input>
					<el-select v-model="documentInfo[attr.attrname]" placeholder="请选择默认项">
						<el-option v-for="item in attr.attrvalue" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</template>
				<template v-else-if="attr.inputtype == 'date'">
					<el-date-picker v-model="documentInfo[attr.attrname]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
				</template>
				<template v-else-if="attr.inputtype == 'datetime'">
					<el-date-picker v-model="documentInfo[attr.attrname]" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
				</template>
				<template v-else>
					<el-input v-model="documentInfo[attr.attrname]" autocomplete="off" :placeholder="attr.typeremark"></el-input>
				</template>
			</el-form-item>

			<el-divider>排序设置</el-divider>
			<el-form-item label="排序" :label-width="formLabelWidth" prop="pid">
				<el-input v-model="documentInfo.pid" autocomplete="off" placeholder="输入排序数字 默认50"></el-input>
			</el-form-item>
			<el-divider>SEO优化设置</el-divider>

			<el-form-item label="自定义网页标题" :label-width="formLabelWidth" prop="headtitle">
				<el-input v-model="documentInfo.headtitle" autocomplete="off" placeholder="请输入自定义网页标题,长度2-50个字符"></el-input>
			</el-form-item>
			<el-form-item label="自定义关键字" :label-width="formLabelWidth" prop="keywords">
				<el-input v-model="documentInfo.keywords" autocomplete="off" placeholder="请输入自定义关键字,多个关键字以小写,隔开,长度2-200位的任意字符"></el-input>
			</el-form-item>
			<el-form-item label="自定义网页简介" :label-width="formLabelWidth" prop="description">
				<el-input
					type="textarea"
					v-model="documentInfo.description"
					:rows="4"
					autocomplete="off"
					:autosize="{ minRows: 4, maxRows: 8 }"
					placeholder="请填写自定义网页简介"
				></el-input>
				<div>
					<el-button type="warning" size="medium" icon="el-icon-s-promotion" @click="chooseSeo('seo')">选择SEO优化词</el-button>
					<el-button type="warning" size="medium" icon="el-icon-s-promotion" @click="chooseSeo('seogroup')">选择优化词分组</el-button>
				</div>
			</el-form-item>

			<el-divider>内容设置</el-divider>

			<el-form-item v-if="dlabel" label="推荐位" :label-width="formLabelWidth" prop="recommend">
				<el-select v-model="documentInfo.recommend" placeholder="请选择所属推荐位" multiple>
					<el-option v-for="(item, index) in dlabel" :key="index" :label="item.labelname" :value="String(item.dlid)"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="所属分类" :label-width="formLabelWidth" prop="tid">
				<el-cascader :options="modelType" :props="{ checkStrictly: true, value: 'tid', label: 'typename' }" v-model="documentInfo.tidgroup" :show-all-levels="false" @change="doctypeChange"></el-cascader>
			</el-form-item>
			<el-form-item v-if="model.isextid" label="附加分类" :label-width="formLabelWidth" prop="extid">
				<el-cascader :options="modelType" :props="{ multiple: true,checkStrictly: true, value: 'tid', label: 'typename' }" v-model="documentInfo.extidgroup" :show-all-levels="false" @change="docextypeChange"></el-cascader>
			</el-form-item>
			<!-- <el-form-item v-if="model.ispurview" label="查看权限" :label-width="formLabelWidth" prop="perview">
				<el-select v-model="documentInfo.perview" placeholder="请选择查看权限">
					<el-option label="标准会员" :value="0"></el-option>
					<el-option label="高级会员" :value="1"></el-option>
				</el-select>
			</el-form-item> -->
			<el-form-item v-if="model.isfgid" label="关联表单" :label-width="formLabelWidth" prop="fgid">
				<el-select v-model="documentInfo.fgid" placeholder="请选择关联表单">
					<el-option v-for="(item, index) in formGroup" :key="index" :label="item.bbsname" :value="item.bid"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="访问量" :label-width="formLabelWidth" prop="click">
				<el-input v-model="documentInfo.click" type="number" autocomplete="off" placeholder="请输入访问量，由大于0的整数数字组成"></el-input>
			</el-form-item>
			<el-form-item v-if="model.islinkdid" label="内容跳转链接" :label-width="formLabelWidth">
				<el-radio v-model="documentInfo.islink" :label="1">开启</el-radio>
				<el-radio v-model="documentInfo.islink" :label="0">关闭</el-radio>
			</el-form-item>
			<el-form-item v-if="documentInfo.islink" label="跳转网址" :label-width="formLabelWidth" prop="link">
				<el-input v-model="documentInfo.link" autocomplete="off" placeholder="请输入跳转网址,跳转网址前请务必加上http://"></el-input>
			</el-form-item>
			<el-form-item label="访问内容" :label-width="formLabelWidth" prop="typename">
				<el-input v-model="documentInfo.linkdid" autocomplete="off" placeholder="请选择访问内容">
					<template slot="append">
						<el-button icon="el-icon-document" @click="chooseBindDoc"></el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item v-if="model.isalbum" label="内容相册" :label-width="formLabelWidth" prop="album">
				<template v-if="documentInfo.album.length">
					<div class="flex" v-for="(album, index) in documentInfo.album" :key="index">
						<img :src="HOST + album.picfile" alt="" :title="album.picfile" style="width: 100px;height: 100px;" />
						<div style="width: calc(100% - 150px);">
							<el-input v-model="album.picname"></el-input>
							<el-input type="textarea" v-model="album.filedes"></el-input>
						</div>
						<i class="el-icon-delete" style="font-size: 20px;" @click="delAlbum('album', index)"></i>
					</div>
				</template>
				<el-button type="warning" icon="el-icon-plus" @click="addPic('album', 'multi')">增加图片</el-button>
			</el-form-item>

			<el-divider>功能设置</el-divider>

			<el-form-item label="页面类型" :label-width="formLabelWidth" prop="ishtml">
				<el-radio v-model="documentInfo.ishtml" :label="0">默认系统</el-radio>
				<el-radio v-model="documentInfo.ishtml" :label="1">静态页面</el-radio>
				<el-radio v-model="documentInfo.ishtml" :label="2">强制动态</el-radio>
			</el-form-item>
			<el-form-item label="留言功能" :label-width="formLabelWidth" prop="ismess">
				<el-radio v-model="documentInfo.ismess" :label="1">开启</el-radio>
				<el-radio v-model="documentInfo.ismess" :label="0">关闭</el-radio>
			</el-form-item>
			<el-form-item label="个性化模板" :label-width="formLabelWidth" prop="istemplates">
				<el-radio v-model="documentInfo.istemplates" :label="1">开启</el-radio>
				<el-radio v-model="documentInfo.istemplates" :label="0">关闭</el-radio>
			</el-form-item>
			<el-form-item v-if="documentInfo.istemplates" label="阅读模板" :label-width="formLabelWidth" prop="template">
				<el-input v-model="documentInfo.template" autocomplete="off" placeholder="请输入每页显示数量,长度2-50个字符">
					<template slot="append">
						<el-button icon="el-icon-document" @click="chooseTemplate('template')">选择模板</el-button>
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="自定义生成文件名" :label-width="formLabelWidth" prop="filename">
				<el-input v-model="documentInfo.filename" autocomplete="off" placeholder="请输入自定义生成文件名，由长度2至50位的英文、数字或下划线组成"></el-input>
			</el-form-item>
		</el-form>
		<div style="margin-bottom: 15px;">
			<el-button type="primary" @click="submitForm('documentForm')">确定保存</el-button>
			<el-button type="default" @click="turnBack()">取消添加</el-button>
		</div>
		<!-- 图片选择组件 -->
		<pic-list ref="picTemp" :type="choosePicType" @confirm="choosePicConfirm"></pic-list>
		<!-- 内容列表组件 -->
		<doc-list ref="docComp" @confirm="chooseDocConfirm"></doc-list>
		<!-- 优化词组件 -->
		<seo-list ref="seoTemp" :seoType="seoType" @confirm="chooseSeoConfirm"></seo-list>
		<!-- 优化词组件结束 -->
		<!-- 模板文件选择组件 -->
		<tempfile-list ref="tempfile" @confirm="chooseTempfileConfirm"></tempfile-list>
	</div>
</template>
<script>
let currVM;
import VueUeditorWrap from 'vue-ueditor-wrap'; // ES6 Module
import docList from '../../components/doclist/doclist.vue';
import picList from '../../components/piclist/piclist.vue';
import seoList from '../../components/seolist/seolist.vue';
import tempfileList from '../../components/tempfilelist/tempfilelist.vue';
export default {
	name: 'addDocument',
	components: {
		VueUeditorWrap,
		docList,
		picList,
		seoList,
		tempfileList
	},
	data() {
		var temCheck = (rule, value, callback) => {
			if (this.documentInfo.styleid == 2) {
				if (!value) {
					callback(new Error('请选择列表模板'));
				} else {
					callback();
				}
			}
		};
		var intemCheck = (rule, value, callback) => {
			if (this.documentInfo.styleid == 1) {
				if (!value) {
					callback(new Error('请选择主页模板'));
				} else {
					callback();
				}
			}
		};
		var retemCheck = (rule, value, callback) => {
			if (this.documentInfo.styleid == 2) {
				if (!value) {
					callback(new Error('请选择阅读模板'));
				} else {
					callback();
				}
			}
		};
		return {
			mlabel: '',
			model: [], //当前内容模型
			modelAttr: [], //模型字段
			modelType: [], //模型分类
			dlabel: [], //内容推荐位
			formGroup: [], //关联表单
			documentInfo: {
				mid: '',
				istsn: 0,
				tsn: '',
				headtitle: '', //自定义网页标题
				keywords: '', //自定义关键字
				description: '', //自定义网页简介
				tid: '', //所属分类
				extid: [], //附加分类
				sid: '', //所属专题
				purview: '', //查看权限
				fgid: '', //关联表单
				click: '', //访问量
				islink: 0, //内容跳转链接
				link: '', //跳转网址http
				linkdid: '', //关联内容
				ishtml: 0, //页面类型 0默认系统1静态页面2强制动态
				ismess: 1, //留言开启关闭
				istemplates: 0, //个性化模板开启关闭
				template: '', //阅读模板 个性化模板开启时
				filename: '', //自定义生成文件名
				album: [], //内容相册，单独存于document_album表
				titlecolor: '#06c' ,//标题默认颜色
				tidgroup:[],//tid分类数组
				extidgroup:[],//extid分类数组
				zoompic:''
			},
			rules: {
				tid: [{ required: true, message: '请选择所属分类', trigger: 'blur' }]
			},
			formLabelWidth: '130px',
			dialogVisible: false,
			myConfig: {
				// 编辑器不自动被内容撑高
				autoHeightEnabled: false,
				// 初始容器高度
				initialFrameHeight: 500,
				// 初始容器宽度
				initialFrameWidth: '100%',
				// 上传文件接口
				serverUrl: this.HOST + this.ueditorPath + '/UEditor/php/controller.php',
				// UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
				UEDITOR_HOME_URL: this.ueditorPath + '/UEditor/',
				catchRemoteImageEnable: false, //设置远程图片是否抓取到本地保存
				iswatermark: false
			},
			seoType: '', //查询类别keyword seo优化词 keylinktype 优化词分组
			tempattr: '', //模板字段名
			addpic_attr: '', //需要上传图片的字段名
			choosePicType: '', //one单图multi多图
			editor: '',
			elseAttr: {}
		};
	},
	mounted() {
		currVM = this;
		let query = this.$route.query;
		this.documentInfo.mid = query.mid;
		this.mlabel = query.mlabel;
		if (query.did) {
			this.documentInfo.did = query.did;
		}
		this.getDocumentInfo();
		this.$on('showPic', function() {
			this.$refs.picTemp.show();
		});
	},
	methods: {
		// 页面初始化获取信息
		getDocumentInfo() {
			this.$axios({
				url: this.HOST + '/admin.document/getDocument',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					mid: this.documentInfo.mid,
					did: this.documentInfo.did ? this.documentInfo.did : ''
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.model = res.data.model;
						this.modelAttr = res.data.modelAttr;
						this.modelAttr.map(item => {
							if (item.inputtype == 'editor') {
								this.$set(this.elseAttr, item.attrname, 1);
							}
						});
						console.log('elseAttr', this.elseAttr);
						this.modelType = res.data.modelType;
						this.dlabel = res.data.dlabel;
						this.formGroup = res.data.formGroup;

						if (this.documentInfo.did) {
							this.documentInfo = res.data.document;
						} else {
							if (res.data.document['istsn'] == 1) {
								this.documentInfo['istsn'] = 1;
								this.documentInfo['tsn'] = res.data.document['tsn'];
							}
							let hasEditor = 0;
							for (let i in this.modelAttr) {
								this.$set(this.documentInfo, this.modelAttr[i].attrname, this.modelAttr[i].attrvalue);
								if (this.modelAttr[i].inputtype == 'editor') {
									hasEditor = 1;
								}
							}
							if (!hasEditor) {
								if (this.$route.query.tid) {
									this.getTypeInfo(this.$route.query.tid);
								}
							}
						}
						this.documentInfo.titlecolor = this.documentInfo.titlecolor ? this.documentInfo.titlecolor : '#06c';
						console.log('docinfo', this.documentInfo);
					}
				})
				.catch(err => {});
		},
		// 获取分类列表
		getTypeInfo(tid) {
			this.$axios({
				url: this.HOST + '/admin.document/getTypeInfo',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					tid: tid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.documentInfo = res.data;
					}
				})
				.catch(err => {});
		},
		// 选择分类
		doctypeChange(e){
			this.documentInfo.tid = e[e.length-1];
		},
		docextypeChange(e){
			console.log(e);
			let arr = [];
			for(let i in e){
				let a = e[i];
				arr.push(a[a.length-1])
			}
			this.documentInfo.extid = arr;
			console.log(this.documentInfo.extid);
		},
		// 编辑器初始化
		ready(editorInstance) {
			console.log(`编辑器实例${editorInstance.key}: `, editorInstance);
			this.editor = editorInstance;
			console.log(this.editor);
			this.editor.addListener('afterinsertimage', (e, b) => {
				console.log('afterinsertimage:', e, b);
				this.saveUeditorImg(b);
			});
			// this.editor.addListener('catchRemoteImage', (e, b) => {
			// 	console.log('catchRemoteImage:', e, b);
			// });
			// this.editor.addListener('catchremotesuccess', (e, b) => {
			// 	console.log('catchremotesuccess:', e, b);
			// });
			if (this.$route.query.tid) {
				this.getTypeInfo(this.$route.query.tid);
			}
		},
		//获取编辑器上传的图片并存储到file数据库
		saveUeditorImg(files) {
			this.$axios({
				url: this.HOST + '/admin.document/saveUeditorImg',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					files: files //数组
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						//上传成功;
					}
				})
				.catch(err => {});
		},
		// 删除数据字段图片
		delAdscopeImg(attr) {
			this.documentInfo[attr] = '';
		},
		submitForm(ruleform) {
			console.log(ruleform);
			this.$refs[ruleform].validate((valid, attr) => {
				if (valid) {
					this.addDocument();
				} else {
					console.log('error submit!!', attr);
					return false;
				}
			});
		},
		// 添加内容
		addDocument() {
			console.log(this.documentInfo);
			this.$axios({
				url: this.HOST + '/admin.document/addDocument',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					documentInfo: this.documentInfo,
					lang: 'cn'
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.updateSiteMap();
						this.$router.go(-1);
						setTimeout(_=>{
							if(!this.documentInfo.did){
								window.open('','_self').close();
							}
						},1500)
						
					}
				})
				.catch(err => {});
		},
		// 更新百度sitemap
		updateSiteMap() {
			this.$axios({
				url: this.HOST + '/admin.document/updateSiteMap',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
				})
				.catch(err => {});
		},
		// 打开模板列表组件
		chooseTemplate(tempattr) {
			this.tempattr = tempattr;
			this.$refs.tempfile.show();
		},
		// 选择模板文件
		chooseTempfileConfirm(e) {
			this.documentInfo[this.tempattr] = e;
		},
		// 打开seo优化组件
		chooseSeo(seoType) {
			this.seoType = seoType;
			this.$refs.seoTemp.show();
		},
		// seo组件返回值
		chooseSeoConfirm(e) {
			console.log(e);
			if (this.seoType == 'seo') {
				if (this.documentInfo.keywords) {
					this.documentInfo.keywords += ',' + e;
				} else {
					this.documentInfo.keywords = e;
				}
			} else if (this.seoType == 'seogroup') {
				this.documentInfo.headtitle = e.keytypename;
				this.documentInfo.keywords = e.keywordlist;
				this.documentInfo.description = e.description;
			}
		},

		// 打开图片选择组件
		addPic(attr, type) {
			console.log(attr);
			this.addpic_attr = attr;
			if (type) {
				this.choosePicType = type;
			}
			this.$refs.picTemp.show(attr);
		},
		// 图片组件返回值
		choosePicConfirm(e) {
			console.log(e);
			if (this.addpic_attr == 'album') {
				if (e.type == 'multi') {
					for (let i in e.files) {
						let album_item = {
							picfile: e.files[i],
							picname: '',
							filedes: ''
						};
						this.documentInfo.album.push(album_item);
					}
				} else {
					let album_item = {
						picfile: e.files,
						picname: '',
						filedes: ''
					};
					this.documentInfo.album.push(album_item);
				}
			} else {
				this.documentInfo[this.addpic_attr] = e.files;
				if(this.addpic_attr == 'pic'){
					this.documentInfo.zoompic = e.zoomfiles;
					console.log('zoomfiles upload success:',this.documentInfo.zoompic);
				}
			}
		},
		// 相册图片移除
		delAlbum(name, index) {
			let file = this.documentInfo[name][index];
			console.log('file', file);
			if (!file.daid) {
				// 数据库没上传直接删除就ok
				this.documentInfo[name].splice(index, 1);
			} else {
				//已存储的同时删除album表数据
				this.$axios({
					url: this.HOST + '/admin.document/delAlbumFile',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						file: file
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.documentInfo[name].splice(index, 1);
						}
					})
					.catch(err => {});
			}
		},
		chooseBindDoc() {
			this.$refs.docComp.show();
		},
		chooseDocConfirm(e) {
			console.log(e);
			this.documentInfo.linkdid = e.did;
		},
		changeEditorOpt(attrname, attrvalue, e) {
			console.log(attrname, attrvalue, e);
			this.myConfig[attrvalue] = e;
			this.elseAttr[attrname] = 0;
			setTimeout(() => {
				this.elseAttr[attrname] = 1;
			}, 5);
		},
		changeThemeColor(e) {
			console.log(e);
		}
	}
};
</script>
<style lang="scss">
.el-button + .el-button-group {
	margin-left: 10px;
	margin-right: 10px;
}
.el-form-item {
	margin-bottom: 20px;
}
.el-alert {
	display: inline;
	.el-alert__content {
		line-height: 20px;
	}
}
.el-select,
.el-date-editor {
	display: block !important;
	width: 100% !important;
}
.haspic .el-upload--picture-card {
	background-color: #fff !important;
	border: none !important;
}
.el-icon-delete {
	&:hover {
		color: red;
		cursor: pointer;
	}
}
</style>
